import React from 'react';

import { Button, Modal } from '@placer-ui/components';
import { TitleModalHeader } from 'features/offline-reports/support-requests/components/support-requests-modals/components/title-modal-header/title-modal-header';
import { useOpenSupportRequest } from 'features/offline-reports/support-requests/components/support-requests-modals/support-modal-manager';
import type { SupportRequestsSuccessModalProps } from 'features/offline-reports/support-requests/components/support-requests-modals/modals/support-success-modal/types';
import { SupportRequestsSuccessContent } from 'features/offline-reports/support-requests/components/support-requests-modals/modals/support-success-modal/support-success-modal-content';

import styles from './support-success-modal.module.scss';

export const SupportRequestsSuccessModal = (props: SupportRequestsSuccessModalProps) => {
    const { closeSupportRequest } = useOpenSupportRequest();

    return (
        <>
            <TitleModalHeader title="Ticket Submitted" />
            <Modal.Content>
                <div className={styles.successContentWrapper}>
                    <SupportRequestsSuccessContent {...props} />
                </div>
            </Modal.Content>
            <Modal.Footer>
                <Modal.Footer.RightControls>
                    <Button
                        testId="support-request-success-modal-close"
                        variant="primary-brand"
                        fullWidth
                        onClick={() => closeSupportRequest('success')}
                    >
                        Close
                    </Button>
                </Modal.Footer.RightControls>
            </Modal.Footer>
        </>
    );
};
